import React from 'react';

function EraserIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
				d='M8.738 7.78l-3.891 3.977c-1.17 1.196-1.755 1.794-1.834 2.523-.017.154-.017.31 0 .464.08.73.664 1.327 1.834 2.523l.149.152c.624.639.937.958 1.31 1.172.218.125.449.222.689.291.413.118.856.118 1.743.118.886 0 1.33 0 1.743-.118.24-.069.471-.166.688-.29.374-.215.686-.534 1.31-1.173l2.845-2.907M8.738 7.78l3.582-3.657C13.706 2.708 14.4 2 15.263 2s1.556.708 2.941 2.125l.743.76C20.316 6.282 21 6.982 21 7.85s-.685 1.566-2.054 2.964l-3.622 3.698M8.738 7.78l6.586 6.732M10 22h11'
			></path>
		</svg>
	);
}

export default EraserIcon;
